import React from 'react';
import PropTypes from 'prop-types';
import { content as contentPropType } from 'lib/CustomPropTypes';
import classNames from 'classnames';
import i18next from 'i18next';
import { timeFrom, isBefore } from 'lib/DateTime';
import getLink from 'lib/getLiveBlogEmbeddedLink';
import Link from 'components/Link';

const ONE_MINUTE = 60000; // Milliseconds
const FIFTEEN_MINUTES = ONE_MINUTE * 15;
// lbp = live-blog-pkg

function Card({
  isBreaking,
  content,
  isEmbedded,
  showTimestamp,
}) {
  const {
    headline,
    date: { publishedAt } = {},
    url,
    id,
  } = content;

  const timetext = (displayDate) => {
    const showJustNow = isBefore(displayDate, ONE_MINUTE);
    return (
      // Need two different spans in order to do cross fade animation
      <React.Fragment>
        <span
          className={classNames('lbp-card__time__just-now', {
            'lbp-card__time--show': showJustNow,
          })}
          data-test="lbp-card__time__just-now"
        >
          {`${i18next.t('Just now')}`}
        </span>
        <span
          className={classNames('lbp-card__time__text', {
            'lbp-card__time--show': !showJustNow,
          })}
          data-test="lbp-card__time__text"
        >
          {`${i18next.t('time_ago', { time: timeFrom(displayDate) })}`}
        </span>
      </React.Fragment>
    );
  };

  const timestamps = (displayDate) => (
    <span
      data-test="lbp-card__time"
      className={classNames('lbp-card__time', {
        'lbp-card__time--just-updated': isBefore(displayDate, FIFTEEN_MINUTES),
      })}
    >
      {timetext(displayDate)}
    </span>
  );

  const { href, deviceUrl } = getLink(url.primary, id, isEmbedded);

  return (
    <li
      data-test="lbp-card"
      className={classNames(
        'lbp-card',
        {
          'lbp-card--breaking': isBreaking,
          'lbp-card--animate-in': isBefore(publishedAt, ONE_MINUTE),
        },
      )}
    >
      {
        // Must send href as null since Link component uses deviceUrl as separate fallback prop
        /* eslint-disable jsx-a11y/anchor-is-valid */
      }
      <Link
        className="lbp-card__link"
        data-test="lbp-card__link"
        href={deviceUrl ? null : href} // use deviceUrl if embedded
        deviceUrl={deviceUrl}
      >
        {showTimestamp && timestamps(publishedAt)}
        <h5 className="lbp-card__headline" data-test="lbp-card__headline">
          {headline.primary || headline.social}
        </h5>
      </Link>
      {
        /* eslint-enable jsx-a11y/anchor-is-valid */
      }
    </li>
  );
}

Card.propTypes = {
  isBreaking: PropTypes.bool,
  content: contentPropType.isRequired,
  isEmbedded: PropTypes.bool,
  showTimestamp: PropTypes.bool,
};

Card.defaultProps = {
  isBreaking: false,
  isEmbedded: false,
  showTimestamp: true,
};

export default Card;
